export default {
  'business-growth': 'Développez votre entreprise',
}
